"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vacancies = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const Vacancy_1 = require("./Vacancy");
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const translate_1 = require("../../../translate");
const SectionHeading_1 = require("../components/SectionHeading");
const useCandidateView_1 = require("../hooks/useCandidateView");
const ExpandButton = styled_1.default.div({
    borderBottomLeftRadius: constants_1.theme.border.radius.normal,
    borderBottomRightRadius: constants_1.theme.border.radius.normal,
    borderTopColor: constants_1.Color.LIGHTER_BLUE,
    borderTopStyle: 'solid',
    borderTopWidth: constants_1.theme.border.width.thin,
    color: constants_1.Color.BLUE,
    fontSize: 14,
    fontWeight: constants_1.theme.font.weight.bold,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 12,
    textAlign: 'center',
    width: '100%',
    '&:hover': {
        backgroundColor: constants_1.Color.LIGHTER_BLUE,
        cursor: 'pointer',
    },
});
const Vacancies = ({ compact, matchingVacancies, matchingVacanciesLoading, onOpenVacanciesClick, onVacancyClick, }) => {
    const { actor, isEditing, isMe } = (0, useCandidateView_1.useCandidateView)();
    const t = (0, translate_1.useTranslations)();
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    if (isEditing() || !actor.can('read', 'vacancies')) {
        return null;
    }
    if (matchingVacanciesLoading) {
        return ((0, jsx_runtime_1.jsx)(elements_1.Flex, { justify: "center", styles: { p: 4 }, children: (0, jsx_runtime_1.jsx)(elements_1.Loader, { color: constants_1.Color.DARK_MEDIUM_GREY }) }));
    }
    if (!matchingVacancies.length) {
        return null;
    }
    const color = compact ? constants_1.Color.DARK_BLUE : constants_1.Color.DARK_GREY;
    return ((0, jsx_runtime_1.jsxs)(elements_1.Paper, { design: compact ? 'blue' : 'white', styles: {
            alignItems: 'flex-start',
            flex: 'col',
        }, children: [(0, jsx_runtime_1.jsxs)(elements_1.Div, { styles: { mb: 2.5, p: 3.5, pb: 0 }, children: [(0, jsx_runtime_1.jsx)(SectionHeading_1.SectionHeading, { styles: { color }, children: isMe
                            ? t.candidate_view.vacancies.jobs_for_you()
                            : t.candidate_view.vacancies.matching_vacancies() }), (0, jsx_runtime_1.jsx)(elements_1.Text, { color: color, size: 6, children: isMe
                            ? t.candidate_view.vacancies.based_on_your_profile()
                            : t.candidate_view.vacancies.based_on_the_candidates_profile() })] }), (0, jsx_runtime_1.jsx)(elements_1.Flex, { col: true, styles: { w: 'full' }, children: matchingVacancies
                    .slice(0, isExpanded ? 10 : 3)
                    .sort((a, b) => b.score - a.score)
                    .map((matchingVacancy) => ((0, jsx_runtime_1.jsx)(Vacancy_1.Vacancy, { compact: compact, matchingVacancy: matchingVacancy, onClick: onVacancyClick }, matchingVacancy.vacancy.id))) }), isExpanded ? ((0, jsx_runtime_1.jsx)(elements_1.Div, { styles: { p: 3.5, pt: 2.5 }, children: (0, jsx_runtime_1.jsx)(elements_1.Button, { design: "primary-inverted", onClick: onOpenVacanciesClick, size: "sm", children: t.candidate_view.vacancies.see_n_matching_jobs() }) })) : ((0, jsx_runtime_1.jsx)(ExpandButton, { onClick: () => setIsExpanded(true), children: t.candidate_view.vacancies.show_more() }))] }));
};
exports.Vacancies = Vacancies;
